"use client"
import { usePathname, useSearchParams } from "next/navigation"
import { Suspense } from "react"

const CanonicalInner = () => {
  const pathname = usePathname()
  const searchParams: any = useSearchParams()

  const queryString = searchParams.toString()
  const hasQuery = queryString.length > 0
  const currentUrl = `https://www.w3era.com${pathname}${hasQuery ? `?${queryString}` : ""}`

  return <link rel="canonical" href={currentUrl} />
}

const Canonical = () => {
  return (
    <Suspense fallback={<link rel="canonical" href="https://www.w3era.com" />}>
      <CanonicalInner />
    </Suspense>
  )
}

export default Canonical
